module.exports = __webpack_public_path__ + "static/media/sok-tender.84d9268a.jpg";